<template>
  <resource-loader :task="task" :resource="modelValue">
    Report not found.
  </resource-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Report } from '@/type';
import { HasTaskMixin } from '@/mixins';
import ResourceLoader from '@/components/loading/ResourceLoader.vue';
import repository from './report-repository';

interface Data {
  task: Promise<Report>|undefined,
}

export default defineComponent({
  emits: ['loaded', 'update:modelValue'],
  mixins: [HasTaskMixin],
  components: {
    ResourceLoader,
  },
  props: {
    reportId: {
      type: Number,
      required: true,
    },
    modelValue: Object as () => Report,
  },
  data(): Data {
    return {
      task: undefined,
    };
  },
  watch: {
    reportId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.reportId);
      this.task.then((report) => {
        this.$emit('update:modelValue', report);
        this.$emit('loaded', report);
      });
    },
  },
});
</script>
